var state = {
    contract:{},    
}


var setContract = function (contract) {
    state.contract = contract;
}


var getContract = function () {
    return state.contract;
}
export default {
    setContract,
    getContract
}